/* eslint-disable no-unused-vars */

export default function ContactsContainer({...params}){

    let contactsList = params.contactsList

    return(
        "Contacts container"
    )
}